<template>
  <div class="ErrorList">
    <el-dialog
        :title="$t('prompt.title')"
        :visible="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        @close="handleClose"
        width="580px"
        center
        style="border-radius: 20px!important;"
    >
      <el-scrollbar style="height: 267px;">
        <div class="error-box" style="margin-top: 10px;">
          <div class="error-item" style="line-height: 1.7em" v-for="(item,index) in messageErrorList" :key="index">
            <p>{{item}}</p>
          </div>
        </div>
      </el-scrollbar>
      <div slot="footer" class="" style="display: flex;justify-content: flex-end;">
        <el-button  class="form-btn btn-blue" @click="handleClose">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "ErrorList",
  props: {
    messageErrorList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleClose () {
      this.$options.cancel('cancel')
    }
  }
}
</script>

<style scoped lang="less">
.ErrorList{
  :deep(.el-dialog){
    border-radius: 20px;
    margin: 0 !important; /* 重置默认的 margin */
    position: absolute; /* 使用绝对定位 */
    top: 50%; /* 距离顶部50% */
    left: 50%; /* 距离左边50% */
    transform: translate(-50%, -50%); /* 偏移自身宽高的50% */
  }
  :deep(.el-dialog__body){
    padding: 0 20px;
  }
  :deep(.el-dialog__header){
    padding: 8px 20px;
    text-align: center;
    //background: linear-gradient(to bottom, #ff7e79, #7876a3);
    background: linear-gradient(to bottom, rgb(2,125,180), #9ed6ef);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
}

</style>